module.exports = __webpack_public_path__ + "media/images/menu-ad-exchange-active-icon-3803c3245f35f14b410cf79151828e99.svg";